import { useLayouts } from "../LayoutsProvider";
import NewLayout from './NewLayout';
import CreatedLayouts from './CreatedLayouts';
import { CardSkeleton } from './SkeletonsLayout';

const AllLayouts = () => {

  const { loading, layouts, refreshLayouts } = useLayouts();

  const headerLayouts   = layouts.filter(current => current.layout_value === 'header');
  const footerLayouts   = layouts.filter(current => current.layout_value === 'footer');
  const notFoundLayouts = layouts.filter(current => current.layout_value === '404-page');

  if ( loading ) return <CardSkeleton />

  if ( layouts.length > 0 ) {
    return (
      <>
        <div className="responsive-site-builder-content">
          {headerLayouts.length > 0 && <CreatedLayouts layout={headerLayouts} showTitle={true} title='Header' refreshLayouts={refreshLayouts} />}
          {footerLayouts.length > 0 && <CreatedLayouts layout={footerLayouts} showTitle={true} title='Footer' refreshLayouts={refreshLayouts} />}
          {notFoundLayouts.length > 0 && <CreatedLayouts layout={notFoundLayouts} showTitle={true} title='404' refreshLayouts={refreshLayouts} />}
        </div>
      </>
    )
  }

  return <NewLayout />
}

export default AllLayouts